import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Usuario/updateUserPassword`, method: 'POST', body: values, token: token})
}